var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'has-value': _vm.value}},[_vm._m(0),_vm._v(" "),_vm._t("label")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('select',{ref:"select",attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":(event) => _vm.$emit('input', event.target.value)}},[_vm._t("default")],2)
}]

export { render, staticRenderFns }